export default {
  videowrapper: 'video-wrapper',
};
